import validate from "/app/node_modules/.pnpm/nuxt@3.3.3_@netlify+blobs@9.1.2_@types+node@18.19.123_db0@0.3.2_ioredis@5.7.0_magicast@0.3.5__bsjyb4ct7qas5zu3ia5jgctso4/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "api-proxy": () => import("/app/src/client/middleware/api-proxy.ts"),
  "auth-guard": () => import("/app/src/client/middleware/auth-guard.ts"),
  "auto-login": () => import("/app/src/client/middleware/autoLogin.ts"),
  "block-route": () => import("/app/src/client/middleware/block-route.ts"),
  "event-page-layout": () => import("/app/src/client/middleware/eventPageLayout.ts"),
  "page-slide": () => import("/app/src/client/middleware/page-slide.ts"),
  "set-intro": () => import("/app/src/client/middleware/setIntro.ts"),
  "set-page-layout": () => import("/app/src/client/middleware/setPageLayout.ts"),
  "toc-route-middleware": () => import("/app/src/client/middleware/toc-route-middleware.ts")
}